import moment from "moment"

export const getTime =(time)=>{
   return time ? moment(time).format("MM/DD/YYYY h:mm A"):""

}